import {
  DefaultQueryParams,
  environmentBuilder,
  GameLiveConnection,
  parseQuery,
} from '@pascal/pascal-core';
import { kenoGameService } from '../gameService';
import { GameLiveConnectionMethod } from './types';
import { ComboKeno10, ComboKeno8, ComboKeno8GameId } from '../../core/constants/appDefaultValues';
import { soundService } from '../baseSoundService';
import { applicationStore } from '../../store/applicationStore';

export class KenoGameConnection extends GameLiveConnection {
  constructor(url) {
    super(url);
  }

  async sendGameGetInitialState(isFirst = true) {
    const { [DefaultQueryParams.PartnerId]: partnerId } = parseQuery(window.location.search);
    if (isFirst) {
      this.executeGameConnections();
    }
    this.getHotAndColdNumbers();
    !applicationStore.isDemo
      ? await super.sendGetInitialState({ partnerId })
      : await this.getDemoInitialState(partnerId);
  }

  doSpin(...args) {
    return applicationStore.isDemo
      ? this.doDemoSpin(...args)
      : this.connection.invoke(GameLiveConnectionMethod.DoSpin, ...args);
  }

  doDemoSpin({ tickets }) {
    const { [DefaultQueryParams.PartnerId]: partnerId } = parseQuery(window.location.search);
    return this.connection.invoke(GameLiveConnectionMethod.DoDemoSpin, {
      tickets,
      partnerId,
      spinId: applicationStore.getDemoSpinId(),
    });
  }

  getDemoInitialState(partnerId) {
    return this.connection.invoke(GameLiveConnectionMethod.GetDemoInitialState, { partnerId });
  }

  onDoSpinResult(callback) {
    this.connection.on(GameLiveConnectionMethod.DoSpinResult, callback);
  }

  onDoDemoSpinResult(callback) {
    this.connection.on(GameLiveConnectionMethod.DoDemoSpinResult, callback);
  }

  onHotAndColdNumbersResult(callback) {
    this.connection.on(GameLiveConnectionMethod.HotAndColdNumbersResult, callback);
  }

  onGetDemoInitialState(callback) {
    this.connection.on(GameLiveConnectionMethod.GetDemoInitialStateResult, callback);
  }

  getHotAndColdNumbers() {
    return this.connection.invoke(GameLiveConnectionMethod.GetHotAndColdNumbers);
  }

  executeGameConnections() {
    super.onBalanceUpdate();
    super.onGameOpen(() => {
      soundService.muteMusic(true);
      soundService.muteSounds(true);
    });
    super.onMaintenanceNotify();
    this.onHotAndColdNumbersResult(
      kenoGameService.handleGetHotAndColdNumbersResult.bind(kenoGameService)
    );

    this.onDoSpinResult(kenoGameService.handleDoSpinResult.bind(kenoGameService));
    this.onDoDemoSpinResult(kenoGameService.handleDoSpinResult.bind(kenoGameService));
    super.onGetInitialStateResult(kenoGameService.onGetInitialStateResult.bind(kenoGameService));
    this.onGetDemoInitialState(kenoGameService.onGetInitialStateResult.bind(kenoGameService));
    super.onClose(kenoGameService.handleConnectionError.bind(kenoGameService));
    super.onReconnected(kenoGameService.handleReconnected.bind(kenoGameService));
    super.onReconnecting(kenoGameService.handleReconnecting.bind(kenoGameService));
  }
}

const query = parseQuery(window.location.search);
const { [DefaultQueryParams.GameId]: gameId } = query;

const { socketUrl } = environmentBuilder(+gameId === ComboKeno8GameId ? ComboKeno8 : ComboKeno10);

export const kenoGameConnection = new KenoGameConnection({ url: `${socketUrl}game` });
